/** Middleware actions that are handled outside of the normal reducer flow. */
export const middlewareAction = {
    /** Opens a browser window or tab using the shared middleware bridge. */
    openWindow: (
        url: string,
        name: string,
        features: string,
    ) => ({
        type: 'middleware/OPEN_WINDOW',
        payload: {url, name, features},
    }) as const,
};
type OpenWindowAction = ReturnType<typeof middlewareAction.openWindow>;

/** Union of app-level middleware actions. */
export type MiddlewareAction = OpenWindowAction;
